import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const ImagesRowRender = ({ index, key, style, ...props }) => {
  const { images, selectedIcon, rowItems, onChange } = props.parent.props;

  return (
    <div key={key} style={style}>
      <div className="row-render__list">
        {images[index].map((image, index) => (
          <div className="row-render__list-wrapper" style={{ width: `${100 / rowItems}%` }} key={`image_list_${index}`}>
            <div
              className={classNames('row-render__list-item', {
                'row-render__list-item-active': Number(image.id) === Number(selectedIcon?.id),
              })}
              style={{ height: style.height }}
              onClick={() => onChange(image)}
            >
              <img src={image.thumbnail_url ? image.thumbnail_url : image.url} alt={image.name} loading="lazy" style={{ maxHeight: style.height - 8 }} />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

ImagesRowRender.propTypes = {
  index: PropTypes.number,
  key: PropTypes.number,
  style: PropTypes.object,
  parent: PropTypes.object,
};

export default ImagesRowRender;
